import axios from 'axios';
let Request = null;
export default Request = function(opt){
	let self = this;
	let opts = opt || {};
	if(!opts.url){
		console.log('缺少url地址');
		return false;
	}

	let obj = {
        method: opts.type || 'POST',
        url: opts.url,
        headers: opts.headers || {
            userId: window.localStorage.getItem('userid'),
            token: window.localStorage.getItem('token')
        },
        timeout: opts.time || 140*1000,
        responseType: opts.dataType || 'json',
    }

    opts["data"] = opts["data"]||{};
    let str = JSON.stringify( opts["data"]);

    opts["data"] = JSON.parse(str);
   
    if( opts.type =='post'){
        obj.data = JSON.stringify(opts.data || {})
    }else{
       	obj.params = opts.data || {}
    }

    axios(obj).then(function(res){

        if(res.status == 200 ){
            if(opts.success){
                opts.success(res.data,res);
            }
        }else{
            if (data.error) {
                opts.error(error);
            }else{
                console.log('网络故障' + data.error);
            }
        }
    }).catch(function (error){
        console.log('回调处理错误',error);
        if (opts.error) {
            opts.error(error);
        }else{
            // console.log('网络故障');
        }
    });
}





// WEBPACK FOOTER //
// ./src/components/common/request/request.js